var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiButton',{staticClass:"ui-header-nav-button component",attrs:{"active":_vm.$route.path === _vm.path,"title":_vm.title},nativeOn:{"click":function($event){return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }